import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface AiStatus {
  available: boolean;
  reason: "not_configured" | "disabled" | "not_in_plan" | null;
  quota: number;
  used: number;
  remaining: number;
}

export const aiStatusKey = (tenantId: string) => ["tenant", tenantId, "ai-status"] as const;

/** Whether this business can use the AI features now, and how many requests are left. */
export function useAiStatus(tenantId: string) {
  return useQuery({
    queryKey: aiStatusKey(tenantId),
    queryFn: () => api.get<AiStatus>(`/t/${tenantId}/ai/status`),
    staleTime: 60_000,
  });
}
